export default __webpack_public_path__ + "static/media/bulb-on.47555b62.svg";